/* ==========================================================
   KEUTEK BLOG CALLOUT SYSTEM
   ========================================================== */

(function () {
  function renderKeutekCallouts() {
    var placeholders = document.querySelectorAll('[data-keutek-callout]');

    if (!placeholders.length) return;

    placeholders.forEach(function (placeholder) {
      var calloutId = placeholder.getAttribute('data-keutek-callout');

      if (!calloutId) return;

      var template = document.querySelector(
        'template[data-keutek-callout-template="' + calloutId + '"]'
      );

      if (!template) return;

      placeholder.replaceChildren(
        template.content.cloneNode(true)
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderKeutekCallouts);
  } else {
    renderKeutekCallouts();
  }
})();